// Autogenerated by Hanako
import { AutoReload } from '../../views/ts/components/AutoReload';
import { Collapse } from '../../views/ts/components/Collapse';
import { LazyLoader } from '../../views/ts/components/LazyLoader';
import { Header } from '../../views/twig/components/Header';
import { ImageParallax } from '../../views/twig/components/ParallaxImage';
import { Accordeon } from '../../views/twig/modules/accordeons';
import { SkillsList } from '../../views/twig/modules/skills_list';
(new AutoReload()).init();
(new Collapse()).init();
(new LazyLoader()).init();
(new Header()).init();
(new ImageParallax()).init();
(new Accordeon()).init();
(new SkillsList()).init();
